export default {
  name: 'Steps',

  // language=HTML
  template: `
    <div class="ui-steps" :class="rootClasses">
      <slot></slot>
    </div>
  `,

  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },

  props: {
    modelValue: {
      type: Number,
      default: 0,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
    centered: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    rootClasses() {
      return {
        'is-horizontal': !this.vertical,
        'is-vertical': this.vertical,
        'is-centered': this.centered,
      }
    },
  },

  methods: {
    syncStepIndices() {
      this.$children.forEach((child, index) => {
        if (typeof child.setIndex === 'function' && child.index !== index) {
          child.setIndex(index)
        }
      })
    },
  },

  mounted() {
    this.syncStepIndices()
  },

  updated() {
    this.syncStepIndices()
  },
}
